module.exports = __webpack_public_path__ + "img/apm-amex.f598e0bb.svg";